import { useTranslation } from "react-i18next";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ChevronLeft, Mail, SunDimIcon } from "lucide-react";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/verify-request")({
  component: VerifyRequestPage,
});

export default function VerifyRequestPage() {
  const { t } = useTranslation();

  return (
    <div className="container flex h-screen w-screen flex-col items-center justify-center">
      <Link to="/" className={cn(buttonVariants({ variant: "ghost" }), "absolute left-4 top-4 md:left-8 md:top-8")}>
        <>
          <ChevronLeft className="mr-2 h-4 w-4" />
          {t("Back")}
        </>
      </Link>
      <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
        <div className="flex w-full flex-col items-center justify-center space-y-2 text-center">
          <SunDimIcon className="h-16 w-16 text-primary" />
          <h1 className="text-2xl font-semibold tracking-tight">{t("We sent you a login link.")}</h1>
          <p className="text-sm text-muted-foreground">{t("If you don't see it, check your spam folder.")}</p>
          <Mail className="h-8 w-8" />
        </div>
      </div>
    </div>
  );
}
